module.exports = __webpack_public_path__ + "img/Phrase Analyser.fcff377e.svg";